import {injectable} from "inversify";
import Scene = Phaser.Scene;
import {Player, ReferralBonus, UserSource} from "@/store/player/types";
import {EverydayRewardPanel} from "@/scenes.ui/everyday-reward-panel";
import PlayerStore from "@/store/player";
import SoundUtils from "@/utils/sound-utils";
import {IntegrationUtils} from "@/utils/integration-utils";
import {InfoPanel} from "@/scenes.ui/info-panel";
import {TabName} from "@/services/shop-service";
import { Tr } from "@/i18n/i18n";
import {ReferralRewardPanel} from "@/scenes.ui/referral-reward-panel";

@injectable()
export class RewardService {

    public giveEverydayReward(scene: Scene, canvas: HTMLCanvasElement, player: Player,
                     awardSound: (Phaser.Sound.BaseSound | undefined), clickSound: (Phaser.Sound.BaseSound | undefined), popupCampaignCallback: () => unknown,): void {

        let canShare = player.userSource === UserSource.ok;
        if (canShare) {
            IntegrationUtils.initOkAPI();
        }
        let erp = new EverydayRewardPanel(scene, canvas, player, canShare, (shareCheck: boolean) => {
            SoundUtils.play(clickSound);
            PlayerStore.takeEverydayReward();
            if (shareCheck) {
                IntegrationUtils.showOkPostDialog(() => {

                    let ip: InfoPanel = new InfoPanel(scene, canvas!, Tr('izumrudi').toUpperCase(), Tr('accept.15.donate'),
                        Tr('with.us'), () => {
                            PlayerStore.takeOkDaily();
                        }, Tr('gdpr.accept.button'));

                    ip.openAnimated();

                });
            }
            popupCampaignCallback();
        });
        SoundUtils.play(awardSound);
        erp.openAnimated();
    }

    public giveReferralReward(scene: Scene, canvas: HTMLCanvasElement, referralBonus: ReferralBonus, player: Player,
                              awardSound: (Phaser.Sound.BaseSound | undefined), clickSound: (Phaser.Sound.BaseSound | undefined), popupCampaignCallback: () => unknown) {
        let erp = new ReferralRewardPanel(scene, canvas, referralBonus, player,() => {
            SoundUtils.play(clickSound);
            PlayerStore.takeReferralBonus();
        });
        SoundUtils.play(awardSound);
        erp.openAnimated();

    }

}
